export class RoleGroup {

	static ADMIN_GROUP_NAME = 'Socrates_Admin';

	constructor(private _name: string) { }

	get name(): string {
		return this._name;
	}
}
